var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProfileSubsectionTitle',{attrs:{"subsection_title":"Education"}}),_vm._l((_vm.educations),function(education){return _c('EducationItem',{key:education.id,attrs:{"education":education}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }